import { createApp } from 'vue'
import { createStore } from 'vuex'

const store = createStore({
    state: {
        backendUrl: 'https://takebonus.xyz/botmanager',
    },
    mutations: {},
    actions: {},
    modules: {},
    getters: {
        getServerUrl: (state) => {
            return state.backendUrl
        },
    },
})

export default store
